import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { useState } from "react";
import Studio from "./pages/Studio";
import PinPrompt from "./components/PinPrompt";

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem("delogo_access_pin"));

  return (
    <div className="App">
      <div className="grain-overlay" aria-hidden="true" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={isAuthenticated ? <Studio /> : <PinPrompt onAuthenticated={() => setIsAuthenticated(true)} />} />
        </Routes>
      </BrowserRouter>
      <Toaster
        position="top-right"
        theme="dark"
        toastOptions={{
          style: {
            background: "#141414",
            color: "#FDFDFD",
            border: "1px solid #27272A",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
